import React from "react";

import { useRouter } from "next/router";

import TrackPage from "../components/TrackPage";
import { PageLocaleProvider } from "../contexts/PageLocaleContext";
import MainLayout from "../layout/MainLayout";
import ErrorNotFoundView from "../views/ErrorNotFoundView";

export const getStaticProps = async ({ locale }) => ({
  props: { locale },
});

const Page = ({ locale }) => {
  const router = useRouter();

  return (
    <PageLocaleProvider locale={locale}>
      <MainLayout>
        <TrackPage intent="/404" data={{ path: router.asPath }} />
        <ErrorNotFoundView />
      </MainLayout>
    </PageLocaleProvider>
  );
};

export default Page;
